export const licenseKey = process.env.REACT_APP_DEVEXTREME_LICENSE_KEY;